import React, { Component } from "react";
//import "../../../src/styles/button_style.scss";

//import "../../styles/components/endGameScreen.scss";
import "../../styles/endGameScreen.scss";
import firebase from "firebase";

//Avatars
import koala from "../images/koala.png";
import fox from "../images/fox.png";
import lemur from "../images/lemur.png";
import zebra from "../images/zebra.png";

export default class Highscoretable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      highScoreFirebase: undefined,
      globalHighscoreList: true
    };
    localStorage.setItem("found", 0);
  }

  //This code is inspired by the source: https://www.w3resource.com/javascript-exercises/searching-and-sorting-algorithm/searching-and-sorting-algorithm-exercise-4.php
  sortHighScore = items => {
    for (var i = 0; i < items.length; i++) {
      let value = items[i];
      // store the current item value so it can be placed right
      for (var j = i - 1; j > -1 && items[j].points > value.points; j--) {
        // loop through the items in the sorted array (the items from the current to the beginning)
        // copy each item to the next one
        items[j + 1] = items[j];
      }
      // the last item we've reached should now hold the value of the currently sorted item
      items[j + 1] = value;
    }

    return items.reverse();
  };
  //End of inspired code

  readPointsFromFirebase = () => {
    const database = firebase.database().ref("username");

    database.on("value", snapshot => {
      let username = snapshot.val();
      let newState = [];
      for (let user in username) {
        newState.push({
          user: user,
          points: username[user].points,
          profilePictureUrl: username[user].profilePictureUrl,
          countryOne: username[user].countryOne,
          countryTwo: username[user].countryTwo,
          countryThree: username[user].countryThree,
          avatar: username[user].avatar
        });
      }

      let sortedScoreList = this.sortHighScore(newState);

      this.setState({
        highScoreFirebase: sortedScoreList
      });
    });
  };

  switchHighscoreList = () => {
    this.setState({
      globalHighscoreList: !this.state.globalHighscoreList
    });

    localStorage.setItem("found", 0);
  };

  whichNameToHighlight = name => {
    if (localStorage.getItem("found") === 1) {
      return "#";
    } else if (localStorage.getItem("username_full_name") === name) {
      localStorage.setItem("found", 1);
      return "currentPlayer";
    } else if (
      localStorage.getItem("username") === name &&
      !localStorage.hasOwnProperty("username_full_name")
    ) {
      localStorage.setItem("found", 1);
      return "currentPlayer";
    } else {
      return "#";
    }
  };

  render() {
    return (
      <div className="endScreen">
        <div class="confetti">
          <div class="confetti-piece" />
          <div class="confetti-piece" />
          <div class="confetti-piece" />
          <div class="confetti-piece" />
          <div class="confetti-piece" />
          <div class="confetti-piece" />
          <div class="confetti-piece" />
          <div class="confetti-piece" />
          <div class="confetti-piece" />
          <div class="confetti-piece" />
        </div>

        <div class="Goodbye-text">
          <div className="Goodbye-text">
            {/*<h2>
              Your Final Score Is:
              <span style={{ color: "#52b452dc" }}>
                {" "}
                {localStorage.getItem("totalscore")}
              </span>
            </h2>*/}
            <div className="Mobile-spacing">
              <br />
            </div>
            {/* This is where highscore is loaded from firebase*/}
            <h5>Leaderboard</h5>

            <div className="highscore__with-toggle--container">
              <div class="emoji-toggle emoji-happy">
                <input
                  checked={!this.state.globalHighscoreList}
                  type="checkbox"
                  id="toggle1"
                  class="toggle"
                  onChange={this.switchHighscoreList}
                />
                <div class="emoji" />
                <label for="toggle1" class="well" />
              </div>
              <h4 style={{ color: "green" }}>
                Your score for these rounds: {this.props.totalScore}
              </h4>

              <p style={{ fontSize: "14px" }}>
                Click the toggle above to switch leaderboard
              </p>
            </div>

            <div className="card highscore__list--container">
              {!this.state.globalHighscoreList
                ? this.state.highScoreFirebase === undefined
                  ? this.readPointsFromFirebase()
                  : this.state.highScoreFirebase
                      .slice(0, 1000)
                      .map((user, placement) => {
                        return (
                          <div className="highscore__list--post--places">
                            <div id={this.whichNameToHighlight(user.user)}>
                              <div className="highscore--flex-container">
                                <p style={{ fontWeight: 900 }}>
                                  {placement + 1}.{" "}
                                  {!(user.profilePictureUrl === "") ? (
                                    <img
                                      className="highscore__profile-pcture"
                                      src={user.profilePictureUrl}
                                      alt="profilepicture"
                                    />
                                  ) : (
                                    <img
                                      className="highscore__profile-pcture"
                                      src={
                                        user.avatar === "Koala"
                                          ? koala
                                          : user.avatar === "Fox"
                                          ? fox
                                          : user.avatar === "Lemur"
                                          ? lemur
                                          : user.avatar === "Zebra"
                                          ? zebra
                                          : koala
                                      }
                                      alt="profilepicture"
                                    />
                                  )}
                                  {user.user}
                                </p>
                                <div />
                              </div>

                              <div className="highscore__list--post--places--countries">
                                <p> {user.countryOne} </p>
                                <p> {user.countryTwo} </p>
                                <p> {user.countryThree} </p>
                              </div>
                            </div>
                          </div>
                        );
                      })
                : this.state.highScoreFirebase === undefined
                ? this.readPointsFromFirebase()
                : this.state.highScoreFirebase
                    .slice(0, 1000)
                    .map((user, placement) => {
                      return (
                        <div
                          id={this.whichNameToHighlight(user.user)}
                          className="highscore__list--post"
                        >
                          <div>
                            <p style={{ fontWeight: 900 }}>
                              {placement + 1}.{" "}
                              {!(user.profilePictureUrl === "") ? (
                                <img
                                  className="highscore__profile-pcture"
                                  src={user.profilePictureUrl}
                                  alt="profilepicture"
                                />
                              ) : (
                                <img
                                  className="highscore__profile-pcture"
                                  src={
                                    user.avatar === "Koala"
                                      ? koala
                                      : user.avatar === "Fox"
                                      ? fox
                                      : user.avatar === "Lemur"
                                      ? lemur
                                      : user.avatar === "Zebra"
                                      ? zebra
                                      : koala
                                  }
                                  alt="profilepicture"
                                />
                              )}
                              {user.user}
                            </p>
                          </div>
                          <div>
                            <p> {user.points}</p>
                          </div>
                        </div>
                      );
                    })}
            </div>

            <div className="Goodbye-text">
              <div className="Mobile-spacing">
                <br />
              </div>
              <div className="highscore__footer--container">
                <img className="koala-end"
                  src={
                    localStorage.getItem("avatar") === "Koala"
                      ? koala
                      : localStorage.getItem("avatar") === "Fox"
                      ? fox
                      : localStorage.getItem("avatar") === "Lemur"
                      ? lemur
                      : localStorage.getItem("avatar") === "Zebra"
                      ? zebra
                      : koala
                  }
                  type="gif"
                  alt="koala"
                  //width="150pt"
                 // height="auto"
                />

                <div style={{ margin: "15px 15px", maxWidth: "200px" }}>
                  <h4>
                    Thank you for playing! I hope you had a blast and
                    <br />
                    wish to see you soon
                    <br />
                    Lots of {localStorage.getItem("avatar")} kisses,
                    <br />
                  </h4>
                </div>
              </div>
            </div>
            <div>
              <button
                className="new-game-button"
                onClick={() => {
                  this.props.goRestart();
                }}
              >
                Start New Game
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
